import styled from "styled-components";

/**
 * Centered investor content frame — gutters, max-width, and vertical rhythm.
 * Used by InvestorLayout; pages should not re-implement outer padding.
 */
export const INVESTOR_CONTENT_MAX_WIDTH = "1520px";
export const INVESTOR_CONTENT_GUTTER_SM = "1rem";
export const INVESTOR_CONTENT_GUTTER_MD = "2rem";
export const INVESTOR_CONTENT_GUTTER_LG = "2.5rem";

export const InvestorContentFrame = styled.div`
  width: 100%;
  max-width: ${INVESTOR_CONTENT_MAX_WIDTH};
  margin: 0 auto;
  padding: 1.25rem ${INVESTOR_CONTENT_GUTTER_SM} 2.5rem;
  min-width: 0;
  box-sizing: border-box;

  @media (min-width: 768px) {
    padding: 1.75rem ${INVESTOR_CONTENT_GUTTER_MD} 3rem;
  }

  @media (min-width: 1200px) {
    padding: 2rem ${INVESTOR_CONTENT_GUTTER_LG} 3.5rem;
  }

  @media (max-width: 480px) {
    padding: 1rem 0.875rem 2rem;
  }
`;

/** Two-column reading layout for investment detail (main + sticky rail). */
export const InvestmentDetailGrid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 1.5rem;
  align-items: start;

  @media (min-width: 992px) {
    grid-template-columns: minmax(0, 1fr) minmax(280px, 30%);
    gap: 2rem 2.5rem;
  }

  @media (min-width: 1200px) {
    grid-template-columns: minmax(0, 71%) minmax(300px, 29%);
    gap: 2.5rem 3rem;
  }
`;

export const InvestmentDetailMainColumn = styled.div`
  min-width: 0;
`;

export const InvestmentDetailRailColumn = styled.aside`
  min-width: 0;
  display: none;

  @media (min-width: 992px) {
    display: block;
  }
`;

export const InvestmentDetailRailSticky = styled.div`
  position: sticky;
  top: 5.75rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-self: start;
`;

/** Page-level wrapper for detail route — mobile bottom bar clearance only. */
export const InvestmentDetailPageFrame = styled.div`
  padding-bottom: 6rem;
  max-width: 100%;
  overflow-x: hidden;

  @media (min-width: 992px) {
    padding-bottom: 2rem;
  }
`;
